import { render } from "./BranchesPage.vue?vue&type=template&id=bf9f3df4"
import script from "./BranchesPage.vue?vue&type=script&lang=js"
export * from "./BranchesPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__